<template>
  <div class="mfaVerificator w-full">
    <div class="flex-row-between">
      <div class="inputWrapper flex-row" v-for="item in amount" :key="item">
        <!-- input -->
        <input
          title="code"
          class="input outline-none"
          v-focus="item - 1 === currentIndex"
          maxlength="1"
          v-model="code[item - 1]"
          @input="handleInput($event, item - 1)"
          @keyup.delete="onDelete($event, item - 1)"
          @keyup.enter="eventSendMFA"
          @paste="handlePaste"
        />
      </div>
    </div>
    <F2gButton
      class="login__card__form__button"
      :loading="loading"
      :text="$t('common.verify')"
      :customClass="!isCustomOwner ? 'primary' : 'blueVolvo'"
      :textColor="!isCustomOwner ? '' : 'primary'"
      @click="eventSendMFA"
    />
  </div>
</template>

<script>
import F2gButton from "@/flit2go-web-core/components/buttons/f2g-button";

export default {
  name: "mfaVerificator",
  components: { F2gButton },
  props: {
    amount: { required: false, type: Number, default: 6 },
    isCustomOwner: { default: false, required: false, type: Boolean },
  },
  data: () => ({
    code: [],
    currentIndex: 0,
    loading: false,
  }),
  directives: {
    focus: {
      componentUpdated: (el, obj) => {
        obj.value && el.focus();
      },
    },
  },
  created() {
    this.code = new Array(this.amount).fill("");
  },
  methods: {
    eventSendMFA() {
      this.loading = true;
      if (!this.code.includes("")) {
        let aux = "";
        this.code.forEach((item) => (aux += item));
        this.$emit("validateToken", aux);
      }
      setTimeout(() => {
      this.loading = false;
      }, 500);
    },
    handleInput(e, index) {
      this.currentIndex = index;
      e.target.value = this.validateNumber(e.target.value);
      e.target.value !== "" && ++this.currentIndex;
      !this.code.includes("") && this.$emit("onCompleted", this.code.join(""));
    },
    onDelete(e, index) {
      if (e.target.value === "") {
        this.currentIndex = index - 1;
      }
    },
    validateNumber(val) {
      return val.replace(/\D/g, "");
    },
    handlePaste(e) {
      e.preventDefault();
    },
  },
};
</script>

<style lang="scss" scoped>
.inputWrapper {
  position: relative;
  width: 15%;
  height: 0;
  padding-bottom: 15%;

  .input {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: all 0.3s;
    font-size: 3vw;
    border-bottom: 2px solid #d6d6d6;
  }
  .input:focus {
    border-bottom: 2px solid $success-f2g;
  }
}
.login__card__form__button {
  border-radius: 40px;
  width: 100%;
  margin-top: 40px;
  cursor: pointer;
}
</style>
